import { render } from "./refundDetails.vue?vue&type=template&id=a917260e&scoped=true"
import script from "./refundDetails.vue?vue&type=script&lang=js"
export * from "./refundDetails.vue?vue&type=script&lang=js"

import "./refundDetails.vue?vue&type=style&index=0&id=a917260e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a917260e"]])

export default __exports__